import React, { Component } from 'react';
import {
  MimeTypeHelper,
  VibeButton,
  VibeDialog,
  UploadDropzone,
  viUpload,
  viArrowRight,
} from 'vibeguide';
import Grid from '@mui/material/Grid';
import UploadStatus from './UploadStatus';
import './UploadContainer.scss';

class UploadContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      files: [],
      isUploadComplete: false,
    };
  }

  /**
   * Set the files to upload
   */
  setFilesToUpload = (files) => {
    this.setState(() => {
      return {
        files,
      };
    });
  };

  /**
   * Reset the upload status to allow more items to be uploaded
   */
  uploadMoreSongs = () => {
    this.setState(() => {
      return {
        files: [],
        isUploadComplete: false,
      };
    });
  };

  /**
   * All Uploading has been Completed
   */
  uploadComplete = () => {
    this.setState(() => {
      return {
        isUploadComplete: true,
      };
    });
  };

  render() {
    const {
      files,
      isUploadComplete,
    } = this.state;

    const isDropzone = files.length <= 0;

    return (
      <VibeDialog
        title="Upload Songs"
        closeDialogLink="/music/songs"
        open
        fullScreen
      >
        <div className="UploadContainer">
          <div className="header">
            <Grid spacing={2} container>
              <Grid className="title" size={6}>
                File Upload
              </Grid>

              {!isDropzone ? (
                <Grid className="toolbar" size={6}>
                  <VibeButton
                    text="Upload More Songs"
                    color="secondary"
                    icon={viUpload}
                    disabled={!isUploadComplete}
                    onClick={this.uploadMoreSongs}
                  />

                  <VibeButton
                    text="Edit Pending Songs"
                    color="primary"
                    link="/music/songs/publish"
                    icon={viArrowRight}
                    iconProps={{
                      placement: 'right',
                    }}
                    disabled={!isUploadComplete}
                  />
                </Grid>
              ) : null}
            </Grid>
          </div>
          <div className={`content ${isDropzone ? 'is-dropzone' : ''}`}>
            {!isDropzone ? (
              <UploadStatus
                files={files}
                onComplete={this.uploadComplete}
              />
            ) : (
              <UploadDropzone
                acceptedMimeTypes={MimeTypeHelper.music}
                allowUpload
                onDrop={this.setFilesToUpload}
              />
            )}
          </div>
        </div>
      </VibeDialog>
    );
  }
}

export default UploadContainer;
